import { ToggleButton } from "@mui/material";
import { Editor } from "@tiptap/react";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";

interface MenuButtonUnderlineProps {
  editor: Editor;
  iconSize?: "small" | "inherit" | "large" | "medium";
}

const PlainIconButton = styled(ToggleButton)(({ theme }) => ({
  border: 0,
  background: "none",
  boxShadow: "none",
  minWidth: 0,
  padding: 4,
  borderRadius: 4,
  "&.Mui-selected": {
    background: "none",
    color: theme.palette.primary.main,
  },
  "&:hover": {
    background: "none",
    color: theme.palette.text.primary,
  },
}));

export function MenuButtonUnderline({ editor, iconSize = "small" }: MenuButtonUnderlineProps) {
  return (
    <PlainIconButton
      value="underline"
      selected={editor.isActive("underline")}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
    >
      <SvgIcon fontSize={iconSize}>
        <FormatUnderlinedIcon />
      </SvgIcon>
    </PlainIconButton>
  );
}
